import React, { useState, useEffect } from 'react';
import { Header } from '../../components/Header/Header';
import { Reveal } from '../../components/Animations/Reveal';
import * as styles from './AWLandingPage.module.css';
import { AWClientsSection } from './components/AWClientsSection';
import { AWAboutSection } from './components/AWAboutSection';


import { AWLogistics } from './components/AWLogistics';
import { AWProducts } from './components/AWProducts';
import { AWProductShowcase } from './components/AWProductShowcase';
import { AWFooter } from './components/AWFooter';
import { useLanguage } from '../../i18n';

const AWLandingPage: React.FC = () => {
    const { t } = useLanguage();
    const bgImageUrl = '/assets/backgounds/001nk_aw_bg.jpg';
    const bgImage = `url(${bgImageUrl})`;
    const [isBgLoaded, setIsBgLoaded] = useState(false);
    const [isTextVisible, setIsTextVisible] = useState(false);
    const [isBlurRemoved, setIsBlurRemoved] = useState(false);

    // 1. Image Preloading
    useEffect(() => {
        const img = new Image();
        img.src = bgImageUrl;
        img.onload = () => {
            setIsBgLoaded(true);
        };
    }, []);

    // 2. Animation Trigger (Runs only after BG is loaded)
    // 2. Animation Trigger (Runs only after BG is loaded)
    useEffect(() => {
        if (isBgLoaded) {
            // Trigger text/content entrance after 1.5 SECOND delay
            const moveTimer = setTimeout(() => {
                setIsTextVisible(true);
            }, 1500);

            // Trigger blur removal shortly after text appears
            const blurTimer = setTimeout(() => {
                setIsBlurRemoved(true);
            }, 2300);

            return () => {
                clearTimeout(moveTimer);
                clearTimeout(blurTimer);
            };
        }
    }, [isBgLoaded]);

    return (
        <div className={styles.awLandingContainer}>
            {/* 1. BACKGROUND (Subtle Zoom In Effect) */}
            <div
                className={styles.bgImage}
                style={{
                    backgroundImage: bgImage,
                    opacity: isBgLoaded ? 1 : 0,
                    transform: isBgLoaded ? 'scale(1.05)' : 'scale(1)',
                    transition: 'opacity 0.5s ease-in-out, transform 7s ease-out'
                }}
            />
            <div className={styles.bgOverlay} />

            {/* Render content ONLY when background is ready */}
            {isBgLoaded && (
                <>
                    {/* 2. HEADER - Fades in after delay */}
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        zIndex: 10000,
                        opacity: isTextVisible ? 1 : 0,
                        transition: 'opacity 1s ease'
                    }}>
                        {isTextVisible && <Header />}
                    </div>

                    <div className={styles.heroSection}>
                        {/* 4. SPLIT LAYOUT */}
                        <div className={styles.splitLayout}>
                            <div className={styles.panelLeft} style={{ position: 'relative' }}>
                                {/* Panel Left Content */}
                            </div>

                            {/* ABSOLUTE CENTER TITLE CONTAINER */}
                            <div className={styles.centerTitleOverlay}>
                                <div className={styles.staggeredTitle}>
                                    <h1
                                        className={`${styles.bigText} ${styles.textSolid}`}
                                        style={{
                                            transform: 'translateX(-10vw)',
                                            opacity: isTextVisible ? 1 : 0,
                                            filter: isBlurRemoved ? 'blur(0px)' : 'blur(10px)',
                                            transition: 'opacity 1s ease-out, filter 1s ease-out',
                                        }}
                                    >
                                        {t.aw.tu} {t.aw.aliado}
                                    </h1>
                                    <h1
                                        className={`${styles.bigText} ${styles.textSolid}`}
                                        style={{
                                            transform: 'translateX(10vw)',
                                            opacity: isTextVisible ? 1 : 0,
                                            filter: isBlurRemoved ? 'blur(0px)' : 'blur(10px)',
                                            transition: 'opacity 1s ease-out, filter 1s ease-out',
                                            transitionDelay: '0.2s'
                                        }}
                                    >
                                        {t.aw.en} {t.aw.aruba}
                                    </h1>
                                </div>
                            </div>

                            <div className={styles.panelRight}>
                                {/* Panel Right Content */}
                            </div>

                            {/* Mobile Central V Icon */}
                            <div
                                className={styles.mobileBlurIcon}
                                style={{
                                    maskImage: "url('/assets/icons/aw_icons/001_res_gb_nk_icon.png')",
                                    WebkitMaskImage: "url('/assets/icons/aw_icons/001_res_gb_nk_icon.png')",
                                    opacity: isTextVisible ? 1 : 0, // Sync with text
                                    transition: 'opacity 1s ease'
                                }}
                            />
                        </div>

                        {/* 5. FOOTER - Fades in with text */}
                        {/* 5. FOOTER - Fades in with text */}
                        <div
                            className={styles.footerRow}
                            style={{
                                opacity: isTextVisible ? 1 : 0,
                                transition: 'opacity 1s ease'
                            }}
                        >
                            <div className={styles.footerLeftGroup}>
                                {isTextVisible && (
                                    <Reveal direction="bottom" delay={0.2}>
                                        <img
                                            src="/assets/icons/aw_icons/001_nk_vba_link.png"
                                            alt="NikoVen Corporation VBA"
                                            className={styles.footerIcon}
                                            onClick={() => window.open('https://nikoven.com', '_blank')}
                                        />
                                    </Reveal>
                                )}
                            </div>

                            <div className={styles.footerRightGroup}>
                                {isTextVisible && (
                                    <img
                                        src="/assets/icons/aw_icons/002_aruba_link.png"
                                        alt="Aruba - One Happy Island"
                                        className={styles.footerIcon}
                                        onClick={() => window.open('https://www.aruba.com', '_blank')}
                                    />
                                )}
                            </div>
                        </div>

                        {/* SCROLL INDICATOR - only valid for Hero section */}
                        <div className={styles.scrollIndicator}>
                            <div className={styles.scrollLine}>
                                <div className={styles.scrollDot} />
                            </div>
                            <span className={styles.scrollText}>SCROLL</span>
                        </div>
                    </div>

                    {/* CLIENTS SECTION (Before About) */}
                    <AWClientsSection />

                    <AWAboutSection />





                    {/* NEW PRODUCTS TRANSITION SECTION */}
                    <AWProducts />

                    {/* NEW LOGISTICS ANIMATION SECTION (CATALOG) */}
                    <AWLogistics />

                    {/* NEW PRODUCT SHOWCASE SCROLL SECTION */}
                    <AWProductShowcase />

                    {/* NEW FOOTER */}
                    <AWFooter />
                </>
            )}

        </div >
    );
};

export default AWLandingPage;